<template>
  <div class="region-table-block my-4">
    <div class="region-table-header">
      <h3 class="region-title">
        {{ regionLabel }}
        <span v-if="region === 'india'" class="region-currency">(INR)</span>
        <span v-else-if="region === 'thailand'" class="region-currency"
          >(Thai Baht)</span
        >
        <span class="region-count">({{ displayedLogs.length }})</span>
      </h3>
      <input
        type="text"
        class="form-control region-search"
        v-model="searchTerm"
        :placeholder="`Search ${regionLabel}...`"
      />
    </div>

    <div class="table-responsive strats-wrapper">
      <table class="table table-bordered custom-table table-hover strats">
        <thead>
          <tr>
            <th scope="col" class="col-sticky col-sticky-0">
              <i class="bi bi-app-indicator"></i>
            </th>
            <th scope="col" class="col-sticky col-sticky-1">SR.No</th>
            <th
              scope="col"
              @click="sort('name')"
              class="sortable col-sticky col-sticky-2"
            >
              process
              <span class="sort-icon" v-if="sortKey === 'name'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('machine')" class="sortable">
              server
              <span class="sort-icon" v-if="sortKey === 'machine'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('team')" class="sortable">
              team
              <span class="sort-icon" v-if="sortKey === 'team'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('time')" class="sortable">
              time
              <span class="sort-icon" v-if="sortKey === 'time'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('net_pnl')" class="sortable">
              net pnl
              <span class="sort-icon" v-if="sortKey === 'net_pnl'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('realised')" class="sortable">
              realised
              <span class="sort-icon" v-if="sortKey === 'realised'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('unrealised')" class="sortable">
              unrealised
              <span class="sort-icon" v-if="sortKey === 'unrealised'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('cost')" class="sortable">
              cost
              <span class="sort-icon" v-if="sortKey === 'cost'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('turnover')" class="sortable">
              turnover
              <span class="sort-icon" v-if="sortKey === 'turnover'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('net_exposure')" class="sortable">
              net exposure
              <span class="sort-icon" v-if="sortKey === 'net_exposure'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('gross_exposure')" class="sortable">
              gross exposure
              <span class="sort-icon" v-if="sortKey === 'gross_exposure'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th
              scope="col"
              @click="sort('open_long_exposure')"
              class="sortable"
            >
              open long exposure
              <span class="sort-icon" v-if="sortKey === 'open_long_exposure'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th
              scope="col"
              @click="sort('open_short_exposure')"
              class="sortable"
            >
              open short exposure
              <span
                class="sort-icon"
                v-if="sortKey === 'open_short_exposure'"
                >{{ sortDirection === 1 ? "▲" : "▼" }}</span
              >
            </th>
            <th scope="col" @click="sort('net_open_amount')" class="sortable">
              net open amount
              <span class="sort-icon" v-if="sortKey === 'net_open_amount'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('gross_open_amount')" class="sortable">
              gross open amount
              <span class="sort-icon" v-if="sortKey === 'gross_open_amount'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('margin')" class="sortable">
              margin
              <span class="sort-icon" v-if="sortKey === 'margin'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('max_margin')" class="sortable">
              max margin
              <span class="sort-icon" v-if="sortKey === 'max_margin'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('net_cash')" class="sortable">
              net cash
              <span class="sort-icon" v-if="sortKey === 'net_cash'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th scope="col" @click="sort('mode')" class="sortable">
              mode
              <span class="sort-icon" v-if="sortKey === 'mode'">{{
                sortDirection === 1 ? "▲" : "▼"
              }}</span>
            </th>
            <th
              scope="col"
              @click="sort('strat_crash_monitor_status')"
              class="sortable"
            >
              Status
              <span
                class="sort-icon"
                v-if="sortKey === 'strat_crash_monitor_status'"
                >{{ sortDirection === 1 ? "▲" : "▼" }}</span
              >
            </th>
            <th scope="col">chart</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, index) in displayedLogs"
            :key="log.name"
            :class="rowClass(log)"
          >
            <td class="col-sticky col-sticky-0">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="visibleLogs.includes(log.name)"
                @click="$emit('toggle-log', log)"
              />
            </td>
            <td class="col-sticky col-sticky-1">{{ index + 1 }}</td>
            <td class="fw-bold col-sticky col-sticky-2">
              <router-link class="process-link" :to="log.get_absolute_url">{{
                log.name
              }}</router-link>
            </td>
            <td>{{ log?.machine }}</td>
            <td>{{ log?.team }}</td>
            <td>{{ formatTime(log.time, 0) }}</td>
            <td :class="pnlClass(log.net_pnl)">
              {{ formatNumber(log.net_pnl, 2) }}
            </td>
            <td :class="pnlClass(log.realised)">
              {{ formatNumber(log.realised, 2) }}
            </td>
            <td :class="pnlClass(log.unrealised)">
              {{ formatNumber(log.unrealised, 2) }}
            </td>
            <td>{{ formatNumber(log.cost, 2) }}</td>
            <td>{{ formatNumber(log.turnover, 2) }}</td>
            <td>{{ formatNumber(log.net_exposure, 2) }}</td>
            <td>{{ formatNumber(log.gross_exposure, 2) }}</td>
            <td>{{ formatNumber(log.open_long_exposure, 2) }}</td>
            <td>{{ formatNumber(log.open_short_exposure, 2) }}</td>
            <td>{{ formatNumber(log.net_open_amount, 2) }}</td>
            <td>{{ formatNumber(log.gross_open_amount, 2) }}</td>
            <td>{{ formatNumber(log.margin, 2) }}</td>
            <td>{{ formatNumber(log.max_margin, 2) }}</td>
            <td>{{ formatNumber(log.net_cash, 2) }}</td>
            <td>
              <span class="mode-badge" :class="modeBadgeClass(log.mode)">{{
                log.mode
              }}</span>
            </td>
            <td>
              <span
                class="status-badge"
                :class="statusBadgeClass(log.strat_crash_monitor_status)"
                >{{ log?.strat_crash_monitor_status }}</span
              >
            </td>
            <td>
              <router-link class="chart-link" :to="`${log.name}/all-chart/`">
                <i class="bi bi-graph-up-arrow"></i>
              </router-link>
            </td>
          </tr>
          <tr>
            <th
              class="text-right font-weight-bold tbody-1st col-sticky col-sticky-0"
            >
              Total
            </th>
            <th class="fw-bold col-sticky col-sticky-1">
              <i class="bi bi-medium"></i>
            </th>
            <th
              class="fw-bold col-sticky col-sticky-2"
              @click="$emit('comb-ind-chart', region)"
            >
              <span class="comb-pnl-link">Comb. PNL</span>
            </th>
            <th class="fw-bold"><i class="bi bi-medium"></i></th>
            <th class="fw-bold"><i class="bi bi-medium"></i></th>
            <th class="fw-bold"><i class="bi bi-medium"></i></th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.net_pnl, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.realised, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.unrealised, 2) }}
            </th>
            <th class="font-weight-bold">{{ formatNumber(totals.cost, 2) }}</th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.turnover, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.net_exposure, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.gross_exposure, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.open_long_exposure, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.open_short_exposure, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.net_open_amount, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.gross_open_amount, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.margin, 2) }}
            </th>
            <th class="text-right font-weight-bold">
              {{ formatNumber(maxMargin, 2) }}
            </th>
            <th class="font-weight-bold">
              {{ formatNumber(totals.net_cash, 2) }}
            </th>
            <th class="fw-bold"><i class="bi bi-medium"></i></th>
            <th class="fw-bold">
              <i class="bi bi-medium"></i>
            </th>
            <th class="fw-bold">
              <span class="chart-link" @click="$emit('comb-chart', region)"
                ><i class="bi bi-graph-up-arrow"></i
              ></span>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegionStrategyTable",
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    region: {
      type: String,
      default: "",
    },
    visibleLogs: {
      type: Array,
      default: () => [],
    },
    currentTime: {
      type: Date,
      default: () => new Date(),
    },
    maxMargin: {
      type: Number,
      default: 0,
    },
  },
  emits: ["toggle-log", "comb-chart", "comb-ind-chart"],
  data() {
    return {
      sortKey: "name",
      sortDirection: 1,
      searchTerm: "",
    };
  },
  computed: {
    regionLabel() {
      if (!this.region) return "";
      return this.region.charAt(0).toUpperCase() + this.region.slice(1);
    },
    displayedLogs() {
      const term = this.searchTerm.trim().toLowerCase();
      let rows = this.logs.filter((log) => this.visibleLogs.includes(log.name));
      if (term) {
        rows = rows.filter(
          (log) =>
            (log.name || "").toLowerCase().includes(term) ||
            (log.machine || "").toLowerCase().includes(term) ||
            (log.team || "").toLowerCase().includes(term) ||
            (log.mode || "").toLowerCase().includes(term)
        );
      }
      return rows.slice().sort((a, b) => {
        if (isNaN(a[this.sortKey]) || isNaN(b[this.sortKey])) {
          if (a[this.sortKey] < b[this.sortKey]) return -1 * this.sortDirection;
          if (a[this.sortKey] > b[this.sortKey]) return 1 * this.sortDirection;
        } else if (
          Number.isInteger(a[this.sortKey]) ||
          Number.isInteger(b[this.sortKey])
        ) {
          const intA = a[this.sortKey];
          const intB = b[this.sortKey];
          if (intA < intB) return -1 * this.sortDirection;
          if (intA > intB) return 1 * this.sortDirection;
        } else {
          const floatA = parseFloat(a[this.sortKey]);
          const floatB = parseFloat(b[this.sortKey]);
          if (floatA < floatB) return -1 * this.sortDirection;
          if (floatA > floatB) return 1 * this.sortDirection;
        }
        return 0;
      });
    },
    totals() {
      const fields = [
        "net_pnl",
        "realised",
        "unrealised",
        "cost",
        "turnover",
        "net_exposure",
        "gross_exposure",
        "open_long_exposure",
        "open_short_exposure",
        "net_open_amount",
        "gross_open_amount",
        "margin",
        "net_cash",
      ];
      const t = {};
      fields.forEach((f) => (t[f] = 0));
      this.displayedLogs.forEach((log) => {
        fields.forEach((f) => {
          const v = parseFloat(log[f]);
          if (!isNaN(v)) t[f] += v;
        });
      });
      return t;
    },
  },
  methods: {
    sort(key) {
      if (key === this.sortKey) {
        this.sortDirection *= -1;
      } else {
        this.sortKey = key;
        this.sortDirection = 1;
      }
    },
    pnlClass(val) {
      const n = parseFloat(val);
      if (n > 0) return "pnl-positive";
      if (n < 0) return "pnl-negative";
      return "";
    },
    statusBadgeClass(status) {
      if (!status) return "badge-unknown";
      const s = status.toLowerCase();
      if (s === "connected") return "badge-connected";
      if (s === "stopped") return "badge-stopped";
      if (s === "paused") return "badge-paused";
      if (s === "disconnected") return "badge-disconnected";
      if (s === "no data") return "badge-no-data";
      if (s === "old data") return "badge-old-data";
      if (s === "unexpected") return "badge-unexpected";
      if (s === "fail") return "badge-fail";
      return "badge-unknown";
    },
    modeBadgeClass(mode) {
      if (!mode) return "badge-mode-unknown";
      if (mode === "NORMAL") return "badge-mode-normal";
      if (mode === "HALTED") return "badge-mode-halted";
      if (mode === "LIQUIDATE_ONLY") return "badge-mode-liquidate";
      return "badge-mode-unknown";
    },
    formatNumber(num, des) {
      return parseFloat(num).toFixed(des);
    },
    formatTime(num) {
      if (num) {
        let time = num.split(".");
        return time.length > 0 ? time[0] : null;
      }
      return null;
    },
    rowClass(log) {
      const fiveMinutesInMilliseconds = 5 * 60 * 1000;
      const currentYear = this.currentTime.getFullYear();
      const currentMonth = this.currentTime.getMonth();
      const currentDate = this.currentTime.getDate();
      const updatedTime = new Date(
        currentYear,
        currentMonth,
        currentDate,
        log.time.slice(0, 2),
        log.time.slice(2, 4),
        log.time.slice(4)
      );
      return this.currentTime - updatedTime > fiveMinutesInMilliseconds
        ? "red"
        : "";
    },
  },
};
</script>

<style scoped>
.region-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.region-title {
  margin: 0;
  font-size: 1.2rem;
}
.region-count {
  font-size: 0.9rem;
  opacity: 0.7;
}
.region-currency {
  font-size: 0.85rem;
  font-weight: 600;
  opacity: 0.8;
  margin-left: 2px;
}
.region-search {
  max-width: 240px;
}
</style>
